module.exports = __webpack_public_path__ + "cf256dec26b6103e2599274467f6f43d.svg";